export default "__VITE_ASSET__fNRBUn$D__"